export const ComingSoon = () => (
  <div className="w-100 d-flex p-4 justify-content-center">
    <p className="display-6 text-muted">Coming Soon</p>
  </div>
);
